import { Injectable } from '@angular/core';
import { CoreRepository } from '@tcc-mono/shared/data-access';
import { Vehicle } from '@tcc-mono/vandijk/shared/data-access/models';
import { VehicleService } from '@tcc-mono/vandijk/shared/data-access/vandijk-api';

@Injectable({
  providedIn: 'root'
})
export class VehicleRepository extends CoreRepository<Vehicle> {

  public constructor(
    protected readonly _vehicleService: VehicleService
  ) {
    super(
      { name: 'vehicles' },
      _vehicleService
    );
  }
}
